export const can_access = (permissionList, permission, role_id) => {
    // ** Find permission
    const foundPermission = permissionList.find(perm => perm.permission_name === permission)
    if(foundPermission !== undefined) {
        return role_id == foundPermission.role_id
    }
    return false
}
